/**
 * Utilitário para trabalhar com o sistema de grid
 */

/**
 * Converte um valor de largura de coluna (1-12) para a classe CSS correspondente do Tailwind
 * @param width Largura da coluna (1-12)
 * @returns Classe CSS do Tailwind correspondente
 */
export function getColumnWidthClass(width: number): string {
    // Garante que o valor está entre 1 e 12
    const safeWidth = Math.max(1, Math.min(12, Math.floor(width)));

    // Mapeia para as classes do Tailwind
    // Tailwind usa frações como w-1/2, w-1/3, w-2/3, w-1/4, w-3/4, etc.
    // Para 12 colunas, precisamos mapear para as frações correspondentes
    switch (safeWidth) {
        case 1: return 'w-1/12';
        case 2: return 'w-2/12'; // ou 'w-1/6'
        case 3: return 'w-3/12'; // ou 'w-1/4'
        case 4: return 'w-4/12'; // ou 'w-1/3'
        case 5: return 'w-5/12';
        case 6: return 'w-6/12'; // ou 'w-1/2'
        case 7: return 'w-7/12';
        case 8: return 'w-8/12'; // ou 'w-2/3'
        case 9: return 'w-9/12'; // ou 'w-3/4'
        case 10: return 'w-10/12';
        case 11: return 'w-11/12';
        case 12: return 'w-full';
        default: return 'w-full';
    }
}
